import { AxiosResponse } from 'axios'
import { useEffect, useState } from 'react'

import { useAppErrorContext } from 'contexts/AppErrorContext'

interface Params<T> {
  getData: (() => Promise<AxiosResponse<T>> )| boolean
  initData?: T | null
  customErrorHandle?: boolean
  deps?: any[]
  fetchIf?: boolean
  onSuccess?: (data: T) => void
}

export const useFetch = <T>({
  getData,
  initData = null,
  customErrorHandle = false,
  deps = [],
  fetchIf = true,
  onSuccess,
}: Params<T>) => {
  const [data, setData] = useState<T | null>(initData)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<any>(null)

  const { setAppError } = useAppErrorContext()

  const fetchData = async () => {
    setLoading(true)
    if (fetchIf) {
      try {
        if (typeof getData !== 'boolean') {
          const { data } = await getData()
          setData(data)
          if (onSuccess) onSuccess(data)
        }
      } catch (e: any) {
        if (!customErrorHandle) setAppError(e)
        else setError(e)
      } finally {
        setLoading(false)
      }
    } else {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchData()
  }, [...deps])

  return { data, loading, error, fetchData }
}
